<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // COMPONENTS
    import Navigation from 'src/app/library/navigation/Navigation.svelte';
    import Onboarding from 'src/app/library/onboarding/Onboarding.svelte';

    // STYLING
    import 'tailwindcss/tailwind.css';

</script>

<Onboarding />

<div id = 's8-layout-inside'>

    <nav>
        <Navigation />
    </nav>

    <div class = 's8-content'>

        <div class = 's8-wrap'>

            <main>
                <slot name = 'main'>main</slot>
            </main>

            {#if 'aside' in $$slots}
                <aside>
                    <slot name = 'aside'></slot>
                </aside>
            {/if}

        </div>

    </div>

</div>

<style lang='postcss'>

    div#s8-layout-inside {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;

        div.s8-content {
            container-type: inline-size;
            container-name: contentcontainer;
            display: flex;
            flex-grow: 1;
            max-width: 1200px;

            div.s8-wrap {
                flex-grow: 1;

                main {
                    flex-grow: 1;
                }
            }
        }
    }


    :global(div.s8-alert-bar) {
        &  + div#s8-layout-inside {
            top: 50px;

            nav {
                top: 50px;
            }
        }
    }

    @container contentcontainer ( max-width: 850px) {
        div.s8-wrap {
            flex-direction: column !important;
            overflow: scroll !important;

            aside {
                order: -1 !important;
                flex: 0 0 auto !important;
                padding: 20px !important;
                display: none;
            }

            main {
                overflow: visible !important;
                padding: 20px !important;
            }
        }
    }

    @container contentcontainer ( min-width: 850px) {
        div.s8-wrap {
            flex-direction: row !important;
        }
    }

    @media (max-width: 1000px) {

        div#s8-layout-inside {
            display: flex;
            padding-top: 50px;
            overflow: hidden;

            nav {
                position: fixed;
                z-index: 20;
                right: 0px;
                left: 0px;
                top: 0px;
            }

            div.s8-content {
                max-height: 100%;

                div.s8-wrap {
                    display: flex;
                    max-height: 100%;

                    main {
                        padding: 20px;
                        max-height: 100%;
                        overflow: auto;
                    }

                    aside {
                        padding: 20px;
                        flex: 0 0 280px;
                    }
                }
            }
        }
    }

    @media (min-width: 1000px) {

        div#s8-layout-inside {
        display: flex;

            nav {
                flex: 0 0 240px;
            }

            div.s8-content {
                flex-grow: 1;

                div.s8-wrap {
                    display: flex;
                    max-height: 100%;

                    main {
                        padding: 20px 10px;
                        max-height: 100%;
                        overflow-y: auto;
                    }

                    aside {
                        padding: 20px 30px 20px 20px;
                        flex: 0 0 280px;
                    }
                }
            }
        }
    }

</style>